import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './config/router';
import './styles/global.css';
import ReactVLibras from 'react-vlibras-plugin';

const AppWrapper = () => {
  return (
    <>
      <RouterProvider router={router} />
      <ReactVLibras position="right" avatar="guga" opacity={0.8} />
    </>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
);
